<template>

	<!-- Content area -->
	<div class="content content-login justify-content-center align-items-center">
		
		<div class="row no-gutter" style="margin-right: 0; margin-left: 0;">
			<div class="col-md-8 d-none d-md-flex bg-image" v-bind:style="swapseason()">
				
			</div>
			<div class="col-md-4 bg-light bar-login" v-show="statoLogin == 0">
				<div class="login d-flex align-items-center py-5">
					<div class="container">
						<div class="row">
							<div class="col-lg-10 col-xl-7 mx-auto">
								<h3 class="display-login">Login Amministratore</h3>
								<p class="text-muted mb-4">Inserisci la tua Login e Password per entrare.</p>
								
								<div class="form-floating mb-3">
									<input type="text" class="form-control shadow-sm px-4" v-model="utente.USERNAME" placeholder="Email address">
									<label for="floatingInput">Email address</label>
								</div>
								<div class="form-floating">
									<input :type="pwd" id="pwd" class="form-control shadow-sm px-4 text-primary" v-on:keyup.enter="login()" v-model="utente.PASSWORD" placeholder="Password">
									<a v-on:click="togglePassword()" class="form-control-feedback cursor-pointer">
										<i class="icon-lock2 text-muted"></i>
									</a>
									<label for="floatingPassword">Password</label>
								</div>
								<br />
								<button v-on:click="login()" class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm">Collegati</button>
								<div class="text-center d-flex justify-content-between mt-4">
									<p class="form-text text-center text-muted">By continuing, you're confirming that you've read<br />
										our <a href="#">Terms &amp; Conditions</a> and <a href="#">Cookie Policy</a>
									</p>
								</div>
								
								<div class="copyco">
									<p class="text-muted">&copy; 2022 <a href="https://www.webfortravel.it" target="_blank">Web for Travel</a></p> 
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4 bg-light bar-login" v-show="statoLogin == 1">
				<div class="login d-flex align-items-center py-5">
					<div class="container">
						<div class="row">
							<div class="col-lg-10 col-xl-7 mx-auto">
								<h3 class="display-login">Codice di verifica</h3>
								<p class="text-muted mb-4">Un codice di conferma a 6 cifre è stato inviato al tuo indirizzo Email.</p>

								<template v-if="otpCountdown > 0">
									<p class="text-muted small mb-3">
										Il codice scade tra <strong>{{ otpCountdownFormatted }}</strong>
									</p>
									<div class="form-floating mb-3">
										<input type="text" class="form-control shadow-sm px-4" v-model="otp" placeholder="Codice di verifica">
										<label for="floatingInput">Il tuo Codice OTP</label>
									</div>
									<br />
									<button v-on:click="loginByOtp()" class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm">Collegati</button>
								</template>
								<template v-else>
									<p class="text-danger mb-3">Il codice OTP è scaduto.</p>
									<button v-on:click="resendOtp()" class="btn btn-secondary btn-block text-uppercase mb-2 rounded-pill shadow-sm">Richiedi di nuovo</button>
								</template>


								<div class="copyco">
									<p class="text-muted">&copy; 2022 <a href="https://www.webfortravel.it" target="_blank">Web for Travel</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4 bg-light bar-login" v-show="statoLogin == 2">
				<div class="login d-flex align-items-center py-5">
					<div class="container">
						<div class="row">
							<div class="col-lg-10 col-xl-7 mx-auto">
								<h3 class="display-login">Codice di sicurezza</h3>
								<p class="text-muted mb-4">Inserisci il tuo codice di sicurezza personale a 6 cifre.</p>
								<div class="form-floating mb-3">
									<input type="password" class="form-control shadow-sm px-4" v-model="codiceSicurezza" v-on:keyup.enter="loginByCodiceSicurezza()" placeholder="Codice di sicurezza">
									<label>Il tuo Codice di Sicurezza</label>
								</div>
								<br />
								<button v-on:click="loginByCodiceSicurezza()" class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm">Collegati</button>
								<div class="text-center mt-3">
									<a href="#" class="text-muted small" v-on:click.prevent="inviaCodiceSicurezza()">Hai dimenticato il codice? Invia per email</a>
								</div>
								<div class="copyco">
									<p class="text-muted">&copy; 2022 <a href="https://www.webfortravel.it" target="_blank">Web for Travel</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
	<!-- Content area -->

</template>


<script>
export default {
    name: 'Login',
    data:function(){
        return {
			GLOBAL_IMAGES_PATH:'',
            utente:{
       
            },
			pwd:'password',
			statoLogin:0,
			otp:'',
			otpCountdown:0,
			otpIntervalId:null,
			codiceSicurezza:''
        }
    },

    computed: {
        otpCountdownFormatted() {
            const m = Math.floor(this.otpCountdown / 60);
            const s = this.otpCountdown % 60;
            return `${m}:${s.toString().padStart(2, '0')}`;
        }
    },

    beforeUnmount() {
        if (this.otpIntervalId) clearInterval(this.otpIntervalId);
    },

    methods : {

        login(){	
            global.utils.ajax('core/login',{USERNAME:this.utente.USERNAME,PASSWORD:this.utente.PASSWORD}, (response) => {
                if (response.esito == 0){
					if (response.data.hasOwnProperty("FLG_OTP")){
						this.statoLogin = 1;
						this.utente.ID_UTENTE = response.data.ID_UTENTE;
						this.startOtpTimer();
					}
					else if (response.data.hasOwnProperty("FLG_CODICE_SICUREZZA")){
						this.statoLogin = 2;
						this.utente.ID_UTENTE = response.data.ID_UTENTE;
						this.codiceSicurezza = '';
					}
					else{
						global.utils.setCookie("session_token",response.data.SESSION_TOKEN);
						global.utils.TOKEN = response.token;
						this.$root.startHandler();
					}
                }
                else{
                    global.utils.alert.warning(response.responseText);
                }
            });
        },

		startOtpTimer() {
            if (this.otpIntervalId) clearInterval(this.otpIntervalId);
            this.otp = '';
            this.otpCountdown = 120;
            this.otpIntervalId = setInterval(() => {
                this.otpCountdown--;
                if (this.otpCountdown <= 0) {
                    clearInterval(this.otpIntervalId);
                    this.otpIntervalId = null;
                }
            }, 1000);
        },

		resendOtp() {
            this.login();
        },

		loginByOtp : function(){
            global.utils.ajax('core/loginotp',{ID_UTENTE:this.utente.ID_UTENTE,OTP:this.otp}, (response) => {
				if (response.esito == 0){
					global.utils.setCookie("session_token",response.data.SESSION_TOKEN);
					global.utils.TOKEN = response.token;
					global.utils.setCookie("session_timeout",response.data.SESSION_TIMEOUT);
                    global.utils.TIMEOUT_SESSIONE = response.data.SESSION_TIMEOUT;
                    global.utils.setCookie("session_started_at",response.data.SESSION_STARTED_AT);
                    global.utils.INIZIO_SESSIONE = response.data.SESSION_STARTED_AT;
					if (response.data.API_TOKEN) {
                        global.utils.API_TOKEN = response.data.API_TOKEN;
                        global.utils.setCookie("api_token", response.data.API_TOKEN);
                    }
					this.$root.startHandler();	
				}
			});
		},

		loginByCodiceSicurezza() {
            global.utils.ajax('core/login/codiceSicurezza', { ID_UTENTE: this.utente.ID_UTENTE, CODICE_SICUREZZA: this.codiceSicurezza }, (response) => {
                if (response.esito == 0){
                    global.utils.setCookie("session_token", response.data.SESSION_TOKEN);
                    global.utils.TOKEN = response.token;
                    global.utils.setCookie("session_timeout", response.data.SESSION_TIMEOUT);
                    global.utils.TIMEOUT_SESSIONE = response.data.SESSION_TIMEOUT;
                    global.utils.setCookie("session_started_at", response.data.SESSION_STARTED_AT);
                    global.utils.INIZIO_SESSIONE = response.data.SESSION_STARTED_AT;
                    if (response.data.API_TOKEN) {
                        global.utils.API_TOKEN = response.data.API_TOKEN;
                        global.utils.setCookie("api_token", response.data.API_TOKEN);
                    }
                    this.$root.startHandler();
                }
            });
        },

		inviaCodiceSicurezza() {
            global.utils.ajax('core/login/inviaCodiceSicurezza', { ID_UTENTE: this.utente.ID_UTENTE }, () => {
                global.utils.alert.success('Codice di sicurezza inviato all\'indirizzo email registrato.');
            });
        },

		togglePassword : function(){
			this.pwd = this.pwd == 'password' ? 'text' : 'password';
		},

		swapseason : function(){
			var currentTime = new Date();
			var month = currentTime.getMonth() + 1;
			switch(month) {
				case 6:
				case 7:
				case 8:
					var season = this.GLOBAL_IMAGES_PATH+'BACKGROUNDS/summer.jpg';
					break;
				case 9:
				case 10:
				case 11:
					var season = this.GLOBAL_IMAGES_PATH+'BACKGROUNDS/fall.jpg';
					break;
				case 12:
				case 1:
				case 2:
					var season = this.GLOBAL_IMAGES_PATH+'BACKGROUNDS/winter.jpg';
					break;
				case 3:
				case 4:
				case 5:
					var season = this.GLOBAL_IMAGES_PATH+'BACKGROUNDS/spring.jpg';
					break;					
				default:
					var season = this.GLOBAL_IMAGES_PATH+'/assets/images/backgrounds/login.jpg';
			}
			var stile = {};
			stile['background-image'] = "url('" + season + "')";
			return stile;
		}
		
    },

    created : function(){
		this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
		this.$root.utente = {ID_UTENTE:0,funzionalita: new Array()};
        global.utils.setHeader('fa-sign-in','Login');
    }
}
</script>